import React, { useEffect, useState, useImperativeHandle } from 'react';
import axios from 'axios';

const Test = React.forwardRef((props, ref) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);



   const JwtTkn = 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJEaGFpcnlhIiwiaWF0IjoxNzE4NzAwMzMwLCJleHAiOjE3MTg3MDc1MzB9.sPuGdKUuvoruuwEBDhw0UA-yJKMssw-7qJWjEov1au-YIq9D1AyEonUfwJdNvb7k7nWze8DTOcySzI5csjv6nA'
  const fetchData = async () => {
    try {
      const headers = {
        Authorization: JwtTkn,
        "Content-Type": "application/json",
      };

      const payload = {
        stateCode: '27'
      };

      const response = await axios.post(
        "http://10.226.29.233:8080/eRaktkoshUtilities/eraktkosh/overAllStats",
        payload,
        { headers }
      );

      setData(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useImperativeHandle(ref, () => ({
    fetchData
  }));

  if (loading) return <div>Loading...</div>;

  if (!data) return <div>No data available</div>;

  const { statsData, stateWiseStatsData, todayStatsData } = data;

  return (
    <div>
      <h1>Stats Data</h1>
      {statsData.map((item, index) => (
        <div key={index}>
          {Object.keys(item).map(key => (
            <p key={key}><strong>{key}:</strong> {item[key]}</p>
          ))}
        </div>
      ))}

      <h1>State Wise Stats Data</h1>
      {stateWiseStatsData.map((item, index) => (
        <div key={index}>
          {Object.keys(item).map(key => (
            <p key={key}><strong>{key}:</strong> {item[key]}</p>
          ))}
        </div>
      ))}

      <h1>Today Stats Data</h1>
      {todayStatsData.todayStatsDonorData && todayStatsData.todayStatsDonorData.map((item, index) => (
        <div key={index}>
          {Object.keys(item).map(key => (
            <p key={key}><strong>{key}:</strong> {item[key]}</p>
          ))}
        </div>
      ))}
    </div>
  );
});

export default Test;
